import React from "react"
import { makeStyles } from "tss-react/mui"
import { InputAdornment } from "@mui/material"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { FormikNumberField, FormikTextField } from "../../../../../shared/components/forms/Formik"
import { CreateOrEditVatCodesFormValues } from "../vatCodesTypes"
import { StandardForm } from "../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../shared/components/forms/StandardMainPanel"

const useStyles = makeStyles()(() => ({
    percentageInput: {
        width: "11rem",
    },
}))

export function FormVatCodeContent() {
    const { classes } = useStyles()

    return (
        <StandardForm>
            <StandardMainPanel>
                <LocalizedStrict id="merchant-vat-codes-create-edit-field-code" attrs={{ label: true }}>
                    <FormikTextField<CreateOrEditVatCodesFormValues> name="code" label="Code" fullWidth />
                </LocalizedStrict>
                <LocalizedStrict id="merchant-vat-codes-create-edit-field-name" attrs={{ label: true }}>
                    <FormikTextField<CreateOrEditVatCodesFormValues> name="name" label="Name" fullWidth />
                </LocalizedStrict>
                <LocalizedStrict id="merchant-vat-codes-create-edit-vat-percentage-amount" attrs={{ label: true }}>
                    <FormikNumberField
                        className={classes.percentageInput}
                        name="vatPercentage.amount"
                        range="non-negative-decimal"
                        decimalScale={1}
                        InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
                        label="VAT percentage"
                    />
                </LocalizedStrict>
            </StandardMainPanel>
        </StandardForm>
    )
}
